import type { $Fetch } from 'ofetch';
import type { CobrancaEnvio } from '@/domain/model/CobrancaEnvio';
import type { CobrancaEnvioGateway } from '@/application/port/out/CobrancaEnvioGateway';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const PATH = '/api/v1/commerce/cobranca/envios';

export class HttpCobrancaEnvioGateway implements CobrancaEnvioGateway {
  constructor(private readonly client: $Fetch) {}

  async listRecentes(limit = 100): Promise<CobrancaEnvio[]> {
    const res = await this.client<ApiResponse<CobrancaEnvio[]>>(PATH, { method: 'GET', params: { limit } });
    assertApiSuccess(res);
    return res.data;
  }

  async listByParcela(parcelaId: string): Promise<CobrancaEnvio[]> {
    const res = await this.client<ApiResponse<CobrancaEnvio[]>>(
      `${PATH}/por-parcela/${encodeURIComponent(parcelaId)}`,
      { method: 'GET' },
    );
    assertApiSuccess(res);
    return res.data;
  }
}
